<template>
    <div>
        <vs-row style="width: 100; padding: 10px; background: rgb(244, 247, 248); border-radius: 14px 14px 0px 0px; ">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="11">
                <h4>Sesiones <span v-if="selectedCodigo && selectedCodigo.alias">{{selectedCodigo.alias}}</span></h4> 
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="1">
                <vs-button circle icon floating @click="activeCrear=!activeCrear" :disabled="!crnId">
                    <i class='fas fa-plus mini-icon'></i>
                </vs-button>
                <modal-crear-sesion v-model="activeCrear" :institucion="institucion" :crn-id="crnId" :list-edificios="listEdificios" :list-docentes="listDocentes" :list-dias="listDias" @refreshTable="tablaSesion" ></modal-crear-sesion> 
                <modal-editar-sesion v-model="activeEditar" :row-data="selectedRow" :institucion="institucion" :crn-id="crnId" :list-edificios="listEdificios" :list-docentes="listDocentes" :list-dias="listDias" @refreshTable="tablaSesion" ></modal-editar-sesion>
                <modal-eliminar-sesion v-model="activeEliminar" :row-data="selectedRow" @refreshTable="tablaSesion" ></modal-eliminar-sesion>
            </vs-col>
        </vs-row>
        
        <div v-show="id_crnd" class="text-right my-3">
            <vs-button
                class="ml-auto"
                flat
                success
                @click="isHidden =! isHidden"
            >
                 {{isHidden == false ? 'Subir masivamente' : 'Cerrar'}}
            </vs-button>
            <vs-row v-show="isHidden" class="mt-3">
                <vs-col sm="12" lg="4">
                    <md-menu md-size="small" md-align-trigger >
                        <vs-button
                            color="warn"
                            flat
                            md-menu-trigger
                        >
                            <i class="fas fa-download mr-2"></i> Descargar archivos
                        </vs-button>

                        <md-menu-content>
                            <md-menu-item @click="getDescarga('excel');">Plantilla Excel</md-menu-item>
                            <md-menu-item @click="getDescarga('aulas');">Catálogo Aulas</md-menu-item>
                            <md-menu-item @click="getDescarga('docentes');" >Catálogo Docentes</md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </vs-col>
                <vs-col sm="12" lg="8">
                    <div class="control" style="display: inline-flex; align-items: center; padding-left: 10px;">
                        <input ref="excel" class="file" id="file" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="getCambio()" @click="emptyValue()"/>
                        <label for="file">Seleccionar Archivo</label>
                        <span  class="ml-2">{{nombreExcel ? nombreExcel : 'Archivo'}}</span>
                    </div>
                </vs-col>
            </vs-row>
        </div>
       <vs-table ref="tabla_sesiones" class="tablaSesiones unset-min-width rigth-footer-unset-radius rigth-header-unset-radius">
            <template #thead>
                <vs-tr>
                    <vs-th>
                        Docente
                    </vs-th>
                    <vs-th>
                        Aula
                    </vs-th>
                    <vs-th>
                        Alumnos vinculados
                    </vs-th>
                    <vs-th>
                        Horarios
                    </vs-th>
                    <vs-th>
                        Días
                    </vs-th>                 
                    <vs-th>
                        Acciones
                    </vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in tablaData"
                    :data="tr"
                >
                    <vs-td>
                    {{ tr.docente_en_aula ? tr.docente_en_aula.apellido_paterno + ' ' +tr.docente_en_aula.apellido_materno + ' ' +tr.docente_en_aula.nombres : ''}}
                    </vs-td>
                    <vs-td>
                        <p class="mb-0"><strong>{{tr.aula.edificio.nombre}}</strong></p>
                        <p class="mb-0"><strong>{{tr.aula.nombre}}</strong></p>
                    </vs-td>
                    <vs-td class="text-center">
                        <p v-if="tr && tr.registros_academicos_a_desvincular && tr.registros_academicos_a_desvincular != 0">{{tr.registros_academicos_a_desvincular}}</p>
                        <p v-else>-</p>
                    </vs-td>

                    <vs-td>
                        {{ tr.hora_inicio || tr.hora_fin ? tr.hora_inicio + '-' + tr.hora_fin : ''}}
                    </vs-td>

                    <vs-td>
                        <div v-if="tr.dias">
                            <p>{{getNombreDias(tr.dias)}}</p>
                        </div>
                        <div v-else>
                            <p></p>
                        </div>
                    </vs-td>

                    <vs-td>
                        <div class="grid">
                        <vs-row >
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                                <vs-button icon relief transparent primary animation-type="scale" @click="activeEditar=!activeEditar; selectedRow = tr;" >
                                    <i class="fas fa-edit"></i>
                                    <template #animate >
                                        <i class="fas fa-edit"></i>
                                    </template>
                                </vs-button>
                            </vs-col>
                             <!-- v-if="tr && tr.registros_academicos_a_desvincular && tr.registros_academicos_a_desvincular != 0" -->
                            <vs-col vs-type="flex" v-if="JSON.parse(personaRol).tipoUserPrincipal == 'Personal central - TI'" vs-justify="center" vs-align="center" w="6">
                                <vs-button
                                    icon
                                    relief
                                    transparent
                                    danger
                                    animation-type="rotate"
                                    @click="activeEliminar=!activeEliminar; selectedRow = tr;"
                                >
                                    <i class="fas fa-trash-alt"></i>
                                    <template #animate >
                                        <i class="fas fa-trash-alt"></i>
                                    </template>
                                </vs-button>
                            </vs-col>
                            </vs-row>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
            <template #notFound>
                No hay registros
            </template>
            <template #footer>
                <vs-pagination v-model="page" :length="pages" />
            </template>
        </vs-table> 
        <excel v-model="activeExcel" :nombreCodigo="nombreCodigo" :infoExcel="infoExcel" :crnId="crnId" :institucion="institucion" :docentes="listDocentes" :allAulas="allAulas" @refreshTable="tablaSesion" @regreshExcel="emptyValue"></excel>
    </div>
</template>

<script>
import sesiones from '../../../../api/requests/sesiones.js'
import catalogos from '../../../../api/requests/catalogos.js'
import modalCrearSesion from '../action-modals/sesiones/crear'
import modalEditarSesion from '../action-modals/sesiones/editar'
import modalEliminarSesion from '../action-modals/sesiones/eliminar'
import excel from '../action-modals/sesiones/excel.vue'
export default {
    props:[
        'institucion',
        'crnId',
        'nombreCodigo',
        'ejecutar',
        'selectedCodigo',
        'tipoboton',
        'personaRol'
    ],
    data () {
        return {
            tablaData: [], 
            page: 1, 
            max: 20,
            pages: 0,
            activeCrear: false,
            activeEditar: false,
            activeEliminar: false,
            listDocentes: [],
            listEdificios: [],
            listDias: [],
            selectedRow: null,
            activeExcel: false,
            infoExcel: [],
            isHidden: false,
            archivoExcelRef: [],
            allAulas: [],
            id_crnd: '',
            placeholder: null,
            nombreExcel: '',
            loadingSesion: []
        }
    },
    mounted(){
        $('#file').change(function(e) {
        var filename = e.target.files[0].name
        $('#nombreArchivoDocentes').html(filename);
        })
    },
    methods:{
        getNombreDias(dias){
            return dias
        },
        async openLoading(promise) {
        //   let loading 
        //   try {
        //     loading = this.$vs.loading({
        //         target: this.$refs.tabla_sesiones,
        //     })
        //     const data = await promise
        //     loading.close()
        //     return data
        //   } catch (error) {
        //     if (loading){
        //         loading.close()
        //     }
        //     throw error
        //   }
          
        },
        async tablaSesion () {
            const vm = this
            if(this.tipoboton != 'codigo'){
                vm.loadingSesion = this.$vs.loading({
                    target: this.$refs.tabla_sesiones,
                })
            }
            try {
                this.id_crnd = this.crnId
                const { data: responseCrns = null } = await  sesiones.listadoSesiones(this.id_crnd, {
                    page: this.page || 1,
                    size: this.max || 20
                }) || {}
                const { data: dataCrns = [], per_page = 20, total = 0 } = responseCrns || {}
                this.pages = Math.ceil(total/per_page) || 0
                this.tablaData = dataCrns
                if(this.tipoboton != 'codigo'){
                    console.log("entro a cerrar")
                    vm.loadingSesion.close()
                }
            } catch (error) {
                this.tablaData = []
                this.pages = 1
                if(this.tipoboton != 'codigo'){
                    console.log("entro a cerrar")
                    vm.loadingSesion.close()
                }
            }
        },
        async listadosPorInstitucion (institucionId) {
            if (institucionId) {
                try {
                    const { data: edificios } = await catalogos.getEdificios(institucionId)
                    this.listEdificios = edificios
                } catch (error) {
                    
                }
                try {
                    const { data: docentes } = await catalogos.getDocentes(institucionId)
                    this.listDocentes = docentes
                } catch (error) {
                    
                }
                this.listDias = await catalogos.getDias()
            }
        },
        async getCambio(){
            try{
                this.nombreExcel = this.$refs.excel.files[0].name
                this.archivoExcelRef = this.$refs.excel.files[0]
                const formData = new FormData()
                formData.append('upload_codigo', this.archivoExcelRef)
                const {data : response } = await sesiones.postSubirExcel(this.crnId, formData)
                this.infoExcel = response
                this.activeExcel =! this.activeExcel
            }catch(e){
                console.log(e)
            }

        },
        emptyValue(){
            this.$refs.excel.value = null
            this.nombreExcel = ''
        },
        async getDescarga(tipo){
            if(tipo == 'excel'){
                window.location.href = '/academico-sesiones/downloadExcelAcademico'
            }
            if(tipo == 'docentes'){
                window.location.href = '/academico-sesiones/export_docentes/' + this.institucion
            }
            if(tipo == 'aulas'){
                window.location.href = '/academico-sesiones/export_aulas/' + this.institucion
            }
        },
        postSubirExcel(){
            const archivo = this.$refs.excel.files[0]
            this.archivoExcel = archivo
        },
        async getAllAulas(){
            try{
                const {data : response } = await sesiones.getAllAulas()
                this.allAulas = response
            }catch(e){
                console.log(e)
            }
        }
    },
    components: {
        modalCrearSesion,
        modalEditarSesion,
        modalEliminarSesion,
        excel
    },
    watch:{
        crnId () {
            this.tablaSesion()
            this.getAllAulas()
        },
        ejecutar(){
            if(this.id_crnd){
                this.id_crnd = ''
                this.tablaData = []
            }
        },
        page () {
            this.tablaSesion()
        },
        institucion (val) {
            this.listadosPorInstitucion(val)
        },
    }
}
</script>

<style>
div.tablaSesiones > div.vs-table > table{
    margin: 1.5% 0 !important;
    width: 100% !important;
}
</style>
<style lang="scss" scoped>
.control{
  .file{
    display:none;
    
    color:white;
    & + label{
      font-size:12px;
      color:#fff;
      background:#154360;
      text-align:center;
      vertical-align: text-top;
      padding:5px 8px;
      border:0px solid darken(#154360,30%);
      border-radius: 7px;
      transition:.2s all;
      &:hover{
        cursor:pointer;
        color:darken(#fff,20%);
      }
      & span{
        font-size:12px;
        position:absolute;
        top:60px;
        width:250px;
        text-align:center;
        left:0;
        // background:#fff;
        color:#fff;
      }
    }
  }
}
</style>
